module.exports = __webpack_public_path__ + "static/img/20191205.7df3aa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20191205.jpg
// module id = Ky49
// module chunks = 99